







import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component
export default class ImagePopup extends Vue {
    @Prop()
    protected imageUrl!: string;
    protected isSvg!: boolean;

    constructor() {
        super();
        if(this.imageUrl.endsWith('.svg')) {
            this.isSvg = true;
        }
    }

    private close() {
        this.$emit('close');
    }
}
